import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum EmergencyPreparednessInfoEnum {
    NeedsAssistance = 1,
    ContactMadeWithTheLocal = 2,
    MedicalEquipmentAndSupply = 4,
    AdditionalEmergencyPreparedness = 8
}
class EmergencyPreparednessInfoClass extends EnumWithDescription<EmergencyPreparednessInfoEnum> {
    public readonly enum = EmergencyPreparednessInfoEnum;
    public readonly enumName: string = "EmergencyPreparednessInfoEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<EmergencyPreparednessInfoEnum>> = new Map([
        [
            "NeedsAssistance",
            {
                value: 1,
                name: "Needs assistance during an emergency"
            }
        ],
        [
            "ContactMadeWithTheLocal",
            {
                value: EmergencyPreparednessInfoEnum.ContactMadeWithTheLocal,
                name: "Contact made with the local/state emergency preparedness officials for patient assistance during an evacuation"
            }
        ],
        [
            "MedicalEquipmentAndSupply",
            {
                value: EmergencyPreparednessInfoEnum.MedicalEquipmentAndSupply,
                name: "Medical equipment and supply needs per plan of care"
            }
        ],
        [
            "AdditionalEmergencyPreparedness",
            {
                value: EmergencyPreparednessInfoEnum.AdditionalEmergencyPreparedness,
                name: "Additional emergency preparedness information:"
            }
        ]
    ]);
}
export const EmergencyPreparednessInfo = new EmergencyPreparednessInfoClass();
